import { unit } from "../../../models/response/y-te/unit";
import {
	eUnitActionTypeIds,
	IUnitChangeSelectedIds,
	IUnitCloseConfirm,
	IUnitCloseDetail,
	IUnitDeleteErr,
	IUnitDeleteStart,
	IUnitDeleteSuccess,
	IUnitLoadDetailErr,
	IUnitLoadDetailStart,
	IUnitLoadDetailSuccess,
	IUnitLoadErr,
	IUnitLoadStart,
	IUnitLoadSuccess,
	IUnitSaveErr,
	IUnitSaveStart,
	IUnitSaveSuccess,
	IUnitShowConfirm,
	IUnitShowDetail
} from "../../action-types/y-te/IUnitActionTypes";

export const unitActions = {
	loadUnitStart: (): IUnitLoadStart => {
		return {
			type: eUnitActionTypeIds.LOAD_START
		}
	},
	loadUnitSuccess: (data: unit[]): IUnitLoadSuccess => {
		return {
			type: eUnitActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadUnitError: (message: string): IUnitLoadErr => {
		return {
			type: eUnitActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadUnitDetailStart: (id: number): IUnitLoadDetailStart => {
		return {
			type: eUnitActionTypeIds.LOAD_DETAIL_START,
			payload: id
		}
	},
	loadUnitDetailSuccess: (data: unit): IUnitLoadDetailSuccess => {
		return {
			type: eUnitActionTypeIds.LOAD_DETAIL_SUCCESS,
			payload: data
		}
	},
	loadUnitDetailError: (message: string): IUnitLoadDetailErr => {
		return {
			type: eUnitActionTypeIds.LOAD_DETAIL_ERROR,
			payload: message
		}
	},
	showUnitDetail: (data?: unit): IUnitShowDetail => {
		return {
			type: eUnitActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeUnitDetail: (): IUnitCloseDetail => {
		return {
			type: eUnitActionTypeIds.CLOSE_DETAIL
		}
	},
	changeUnitSelectedIds: (ids: number[]): IUnitChangeSelectedIds => {
		return {
			type: eUnitActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showUnitConfirm: (): IUnitShowConfirm => {
		return {
			type: eUnitActionTypeIds.SHOW_CONFIRM
		}
	},
	closeUnitConfirm: (): IUnitCloseConfirm => {
		return {
			type: eUnitActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveUnitStart: (data: unit): IUnitSaveStart => {
		return {
			type: eUnitActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveUnitSuccess: (is_update: boolean): IUnitSaveSuccess => {
		return {
			type: eUnitActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveUnitError: (message: string): IUnitSaveErr => {
		return {
			type: eUnitActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteUnitStart: (id: number): IUnitDeleteStart => {
		return {
			type: eUnitActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteUnitSuccess: (): IUnitDeleteSuccess => {
		return {
			type: eUnitActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteUnitError: (message: string): IUnitDeleteErr => {
		return {
			type: eUnitActionTypeIds.DELETE_ERROR,
			payload: message
		}
	}
}
